import React, { useEffect } from 'react';
import '../styles/Laser247.css'; 

const Laser247Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="laser247-page">
  <div className="header">
    <h1>
      Welcome to <span className="highlight">Laser247</span>: Your Ultimate <span className="highlight">Betting Destination</span>
    </h1>
    <img src="/laser247.webp" alt="Laser247 Logo" className="logo" />
  </div>

  <section className="laser247-intro">
    <p>
      Step into the world of premier betting with <span className="highlight">Laser247</span>, designed for both beginners and seasoned pros. Curated by <span className="highlight">Reddy Anna</span>, Laser247 offers everything you need for a high-octane betting experience.
    </p>
    <div className="laser247-cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Get in Touch with Us
      </a>
    </div>
  </section>

  <section className="laser247-why-choose">
    <h2>Why Choose <span className="highlight">Laser247</span>?</h2>
    <ol>
      <li>
        <strong>Extensive Betting Choices:</strong> Dive into a variety of betting options, ranging from sports to casino games, all meticulously curated by <span className="highlight">Reddy Anna</span>.
      </li>
      <li>
        <strong>Easy-to-Use Platform:</strong> Enjoy a smooth and intuitive experience with our user-friendly interface, designed for all types of bettors.
      </li>
      <li>
        <strong>Secure Payments:</strong> Rest easy knowing that your transactions are safe with our secure and reliable payment system for deposits and withdrawals.
      </li>
      <li>
        <strong>24/7 Support:</strong> Need help? Our customer support team, managed by <span className="highlight">Reddy Anna</span>, is available anytime to address your queries.
      </li>
    </ol>
    <div className="laser247-cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Get in Touch with Us
      </a>
    </div>
  </section>

  <section className="laser247-features">
    <h2>Distinctive Features of <span className="highlight">Laser247</span></h2>
    <ol>
      <li>
        <strong>Exclusive Access to Laser Book 247:</strong> Unlock exclusive insider information, including expert strategies and tips to enhance your betting success.
      </li>
      <li>
        <strong>Simple Account Access:</strong> Log in quickly and securely, so you can start placing bets in no time.
      </li>
      <li>
        <strong>Attractive Promotions & Bonuses:</strong> Take advantage of generous bonuses, special promotions, and loyalty rewards that enhance your betting journey.
      </li>
    </ol>
  </section>

  <section className="laser247-getting-started">
    <h2>Getting Started with <span className="highlight">Laser247</span></h2>
    <p>Becoming a member of Laser247 is easy:</p>
    <ol>
      <li>
        <strong>Visit Reddy Anna's Website:</strong> Head to our website, click the sign-up button, and get your Laser247 ID through Reddy Anna.
      </li>
      <li>
        <strong>Complete the Registration:</strong> Fill out the necessary details to create your account and verify your identity.
      </li>
      <li>
        <strong>Explore and Bet:</strong> Start browsing our betting options, and place your bets on your favorite games or events.
      </li>
    </ol>
    <div className="laser247-cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Get in Touch with Us
      </a>
    </div>
  </section>

  <section className="laser247-about">
    <h2>About <span className="highlight">Laser247</span> by <span className="highlight">Reddy Anna</span></h2>
    <p>
      <span className="highlight">Laser247</span> by <span className="highlight">Reddy Anna</span> is the ideal platform for online betting enthusiasts, combining innovative features with top-notch service for a seamless experience. With Reddy Anna's vision and commitment to excellence, Laser247 continues to lead in the online betting arena.
    </p>
    <p>
      Join the thrilling world of <span className="highlight">Laser247</span> today, where exciting betting opportunities and significant wins await. Bet confidently and win big at Laser247 – your ultimate betting destination.
    </p>
    <div className="laser247-cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Get in Touch with Us
      </a>
    </div>
  </section>
</div>
  );
};

export default Laser247Page;
